<template>
  <section class="service">
    <h1>{{title}}</h1>
    <p>Huehex can help visualize even the craziest ideas converting them into elegant designs, awesome experiences and catchy brands.</p>
      <div class="row">
        <div class="col-xs-6 col-sm-6 col-lg-3">
            <div class="box linkgroup">
              <figure><img src="@/assets/web.svg" alt=""></figure>
              <div class="title">Web</div>
              <div class="links">
                <router-link to="/">UI/UX design</router-link>
                <router-link to="/">Prototyping</router-link>
                <router-link to="/">IOS & Android </router-link>
                <router-link to="/">Backend</router-link>
                <router-link to="/">Writing & QA</router-link>
              </div>
            </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-lg-3">
            <div class="box linkgroup">
              <figure><img src="@/assets/mobile.svg" alt=""></figure>
              <div class="title">Mobile App</div>
              <div class="links">
                <router-link to="/">UI/UX design</router-link>
                <router-link to="/">Prototyping</router-link>
                <router-link to="/">IOS & Android </router-link>
                <router-link to="/">Backend</router-link>
                <router-link to="/">Writing & QA</router-link>
              </div>
            </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-lg-3">
            <div class="box linkgroup">
              <figure><img src="@/assets/graphic.svg" alt=""></figure>
              <div class="title">Graphic Design</div>
              <div class="links">
               <router-link to="/">Branding</router-link>
               <router-link to="/">Naming</router-link>
               <router-link to="/">Logo design</router-link>
               <router-link to="/">Brand identity</router-link>
               <router-link to="/">Illustration</router-link>
              </div>
            </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-lg-3">
            <div class="box linkgroup">
              <figure><img src="@/assets/motion.svg" alt=""></figure>
              <div class="title">Motion</div>
              <div class="links">
                <router-link to="/">Promo videos</router-link>
                <router-link to="/">Interaction design</router-link>
                <router-link to="/">Motion graphics</router-link>
              </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'service',
  props: {
    title: String
  }
}
</script>

<style scoped lang="scss">
.service{
  p{
    font-size: 30px;
    font-weight: 600;
    font-style: normal;
    line-height: 1.37;
  }
  .title{
    font-size: 35px;
    margin: 50px 0 30px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    color: #ffffff;
  }
  .linkgroup{
    margin-top:100px;
  }
  figure{
    margin: 0;
    display: inline-block;
    position: relative;
    &:before{
      content:'';
      height: 98px;
      width: 98px;
      border-radius: 98px;
      background: $yellow;
      display: block;
      position: absolute;
      top: -30px;
      z-index: -1;
      left: 40px;
    }
  }
  .links{
    padding: 0;
    line-height: 1.25;
    a{
      display: block;
      padding:0.5em 0;
      font-size: 20px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      color: $white;
      text-decoration: none;
    }
  }
}
  
</style>
